/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    appBarSpacer: {
        ...theme.mixins.toolbar,
        [theme.breakpoints.down('xs')]: {
            minHeight: theme.spacing(10),
        }
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        ...theme.custom.apiOverviewPage.tabs.contracts.styles
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        textAlign: 'left',
        maxWidth: '1480px',
    },
    formControl: {
        padding: theme.spacing(2)
    },
    applicationSection: {
        padding: theme.spacing(2),
        alignItems: 'center',
    },
    formControlWarn: {
        padding: theme.spacing(2),
        display: 'flex',
    },
    updateBtn: {
        margin: "32px 0",
        display: 'flex',
        flexDirection: 'row',
        ...theme.custom.apiOverviewPage.tabs.contracts.updateButtonStyle
    },
    updateButton: {
        ...theme.custom.apiOverviewPage.tabs.contracts.updateButton
    },
    radioGroup: {
        width: '360px'
    },
    button: {
        margin: theme.spacing(1, 1, 0, 0),
    },
    warningIcon: {
        ...theme.custom.apiOverviewPage.tabs.contracts.warningIconStyle
    },
    componentPadding: {
        paddingLeft: theme.spacing(7),
        paddingRight: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: 'auto',
            paddingRight: 'auto',
        }
    },
    contractsTitle: {
        ...theme.custom.apiOverviewPage.tabs.contracts.title
    },
    GenerateCredentialsInfoLabel: {
        ...theme.custom.apiOverviewPage.tabs.contracts.GenerateCredentialsInfoLabel
    },
    contractLabel: {
        ...theme.custom.apiOverviewPage.tabs.contracts.contractLabelStyle
    },
    contractRadioButtonStyle: {
        ...theme.custom.apiOverviewPage.tabs.contracts.contractRadioButtonStyle
    },
    selectBox: {
        height: theme.spacing(5),
        width: theme.spacing(30),
        borderRadius: "5px",
        background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
        boxShadow: "inset 0 0 0 1px #dee0e7, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
        cursor: "pointer",
        border: 1,
        "&:active": {
            background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
            boxShadow: "inset 0 0 0 1px #a6b3ff, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
            border: "1px solid #5567d5",
        },
        "&:focused": {
            background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
            boxShadow: "inset 0 0 0 1px #a6b3ff, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
            border: "1px solid #5567d5 !important",
        },
        "& .MuiSelect-selectMenu": {
            "& .TextSpan": {
                color: '#222228'
            }
        },
    },
    dropdownStyle: {
        backgroundColor: "#fff",
        boxSizing: "border-box",
        width: "auto",
        border: "1px solid #DEE0E7",
        borderRadius: "5px",
        boxShadow: "0 5px 10px -3px rgba(50,50,77,0.1)",
        color: "#222228",
        marginTop: '0.25rem',
    },
    policyCardGridItem: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: theme.spacing(2),
    },
    btnText: {
        textTransform: "initial",
        fontSize: 11,
        marginLeft: theme.spacing(1.625),
        fontWeight: 400
    },
}));
